<div>
  <ng-container *ngIf="supportContent$ | async as supportContent">
    <h2 mat-dialog-title>{{'Support' | translate: locale | async}}</h2>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
      <div [innerHTML]="supportContent"></div>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-actions>
      <button mat-raised-button (click)="closeModal()">{{'CLOSE' | translate: locale | async }}</button>
    </div>
</ng-container>
</div>
